import { temAcesso } from '@/shared/auth/temAcesso'

const Contratacoes = () => import('./Contratacoes.vue')
const Contratacao = () => import('./Contratacao.vue')
const Entrega = () => import('./../entregas/Entrega.vue')

export default {
    path: 'contratacoes',
    name: 'Credenciado_Contratacoes',
    component: Contratacoes,
    beforeEnter: (to, from, next) => {
        if (temAcesso('CRED-FORN-CONT-00')) {
            next()
        }
    },
    children: [
        {
            path: ':contratacaoId',
            name: 'Credenciado_Contratacoes_Detalhar',
            component: Contratacao,
            beforeEnter: (to, from, next) => {
                if (temAcesso('CRED-FORN-CONT-01')) {
                    next()
                }
            },
            children: [
                {
                    path: 'entregas/:entregaId',
                    name: 'Credenciado_Entregas_Detalhar',
                    component: Entrega,
                    beforeEnter: (to, from, next) => {
                        if (temAcesso('CRED-FORN-ENTR-01')) {
                            next()
                        }
                    }
                }
            ]
        }
    ]
}
